import { type FC } from "react";
import LocationOff from "@mui/icons-material/LocationOff";
import { Button } from "@mui/material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignOutButton } from "../components/sign-out-button";

interface NoFarmsPageProps {
  onRetry: () => void;
}

export const NoFarmsPage: FC<NoFarmsPageProps> = ({ onRetry }) => (
  <InfoPageLayout>
    <InfoPage
      title="Нет назначенных хозяйств"
      message="Обратитесь к администратору, чтобы вам назначили хозяйство"
      illustration={<InfoPageIllustration icon={LocationOff} />}
      actions={
        <>
          <SignOutButton />
          <Button variant="text" color="primary" onClick={onRetry}>
            Проверить снова
          </Button>
        </>
      }
    />
  </InfoPageLayout>
);
